
import React, { Fragment, useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { push as pushToHistory } from 'redux-first-history';

// Components

import Paginator from '../../../components/common/paginator/Paginator';
import TagsList from './TagsList';
import TagsManagerHeader from './TagsManagerHeader';

// ActionCreators

import { getTags, updateTag } from '../../../actions/ticketMgmtPortal/ticketMgmtPortalActionCreators';
import { hideModal, showModal } from '../../../actions/common/actionCreators';

// Utils

import { sortByNameInAlphabeticalOrder } from '../../../utils/miscellaneous/sortings';

// Constants

import { TAGS_PAGINATION_THRESHOLD } from '../../../constants/common/miscellaneous';
import { ticketMgmtModalTypes } from '../../../constants/ticketMgmt/modals/ticketMgmtModalTypes';


const TagsManagement = props => {

    const {
        getTags,
        hideModal,
        pushToHistory,
        showModal,
        updateTag
    } = props;

    const [ tags, updateTags ] = useState([]);

    const [ page, updatePage ] = useState(0);

    const changePage = newPage => {
        updatePage(newPage);
    };

    const totalPages = useMemo(() => Math.ceil(tags.length), [ tags.length ]);

    const paginatorData = {
        first: page === 0,
        isEmpty: !tags.length,
        last: page === totalPages - 1,
        pageNumber: page,
        totalPages: Math.ceil(tags.length / TAGS_PAGINATION_THRESHOLD)
    };

    useEffect(() => {
        getTags(page)
            .then(res => {
                if(res) {
                    updateTags(sortByNameInAlphabeticalOrder(res));
                }
            });
    }, [ ]);

    const handleTagChange = (...args) => {
        updateTag.apply(null, args)
            .then(data => {
                if(data) {
                    updateTags(sortByNameInAlphabeticalOrder(data));
                    if(data.length !== tags.length) {
                        updatePage(0);
                    }
                    hideModal(ticketMgmtModalTypes.TAG_MODAL);
                }
            });
    };

    const openTagModal = (...args) => {

        const [ id, name ] = args;

        showModal({
            modalType: ticketMgmtModalTypes.TAG_MODAL,
            modalData: {
                id,
                name,
                tags,
                handleTagChange
            }
        });
    };

    return (
        <Fragment>
            <div className="gi-panel">
                <TagsManagerHeader
                    { ...{
                        openTagModal,
                        tagsQty: tags.length
                    } }
                />
                <TagsList
                    { ...{
                        openTagModal,
                        page,
                        pushToHistory,
                        tags
                    } }
                />
                {
                    tags.length > TAGS_PAGINATION_THRESHOLD &&

                    <Paginator
                        { ...{
                            changePage,
                            floatLeft: true,
                            ...paginatorData
                        } }
                    />
                }
            </div>
        </Fragment>
    );
};


export default connect(
    null,
    {
        getTags,
        hideModal,
        pushToHistory,
        showModal,
        updateTag
    }
)(TagsManagement);